import { css } from 'styled-components';

const theme = {
  colors: {
    background: '#131315',
    white: '#fff',
  },
  fonts: {},
  fontWeight: {
    Regular: 400,
    Medium: 500,
    SemiBold: 600,
    Bold: 700,
    ExtraBold: 800,
  },
  RANGE: {
    NONE: 0,
    XS: 4,
    S: 8,
    M: 16,
    L: 24,
    XL: 48,
  },
};

const CENTER = `
  display: flex;
  justify-content: center;
  align-items:center;
  `;
const SPACE_BETWEEN = `
  display: flex;
  justify-content: space-between;
  align-items:center;
  `;
const COLUMN = `
  display: flex;
  flex-direction:column;
`;

const WRAPPER = css`
  max-width: 1132px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    margin: 0 18px;
    margin-top: 16px;
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export { CENTER, COLUMN, SPACE_BETWEEN, WRAPPER, theme };
